export const statusCodeNumericToText = {
  400: 'INVALID_ARGUMENT',
  401: 'UNAUTHENTICATED',
  403: 'PERMISSION_DENIED',
  404: 'NOT_FOUND',
  409: 'ALREADY_EXISTS',
  428: 'FAILED_PRECONDITION',
  429: 'RESOURCE_EXHAUSTED',
  499: 'CANCELED',
  500: 'INTERNAL',
  501: 'NOT_IMPLEMENTED',
  502: 'BAD_GATEWAY',
  503: 'UNAVAILABLE'
};
//# sourceMappingURL=statusCodeNumericToText.js.map